import React from 'react';
import {
  C,
  LEADERBOARD_START_AUDIO_H,
  LEADERBOARD_START_AUDIO_W,
  getPathValue,
  nx,
  ny,
  normalizeAudioField,
} from '../flowCanvas.constants';

function resolveMusic(liveCustomisationData) {
  const musicArr = getPathValue(liveCustomisationData, ['audio', 'leaderboardSoundscape', 'leaderboardMusic']);
  const music = Array.isArray(musicArr) ? (musicArr[0] || {}) : {};
  const file = normalizeAudioField(music?.filename);
  return {
    enabled: music?.playMusic === true,
    label: file?.name || 'No music selected',
  };
}

function resolveStartAudio(liveCustomisationData) {
  const items = getPathValue(liveCustomisationData, ['audio', 'triggerSFX', 'start']);
  const toggleArr = getPathValue(liveCustomisationData, ['audio', 'toggleTriggerSFX', 'toggleSFX']);
  const toggle = Array.isArray(toggleArr) ? (toggleArr[0] || {}) : {};
  const startItems = Array.isArray(items) ? items.filter(Boolean) : [];
  return {
    enabled: toggle?.playStartAudio === true,
    count: startItems.length,
    firstLabel: startItems[0]?.filename || 'No start SFX selected',
  };
}

function SummaryRow({ x, y, width, title, subtitle, active, color, onClick }) {
  return (
    <g
      onClick={(event) => {
        event.stopPropagation();
        onClick?.();
      }}
      style={{ cursor: 'pointer' }}
    >
      <rect
        x={x}
        y={y}
        width={width}
        height="48"
        rx="12"
        fill={active ? `${color}18` : 'rgba(255,255,255,0.04)'}
        stroke={active ? color : 'rgba(255,255,255,0.12)'}
        strokeWidth="1"
      />
      <circle cx={x + 18} cy={y + 24} r="7" fill={active ? color : 'rgba(255,255,255,0.14)'} />
      <text x={x + 34} y={y + 19} fontSize="10" fontWeight="700" fill={C.text} style={{ pointerEvents: 'none', userSelect: 'none' }}>
        {title}
      </text>
      <text x={x + 34} y={y + 33} fontSize="9" fill={active ? '#ffffff' : C.textMuted} style={{ pointerEvents: 'none', userSelect: 'none' }}>
        {subtitle}
      </text>
    </g>
  );
}

export default function LeaderboardStartAudioNode({
  step,
  selected,
  centreY,
  overrideX,
  overrideY,
  liveCustomisationData,
  onActivateMusic,
  onActivateStartAudio,
}) {
  const x = overrideX ?? nx(step);
  const y = overrideY ?? ny(step, centreY);
  const left = x - LEADERBOARD_START_AUDIO_W / 2;
  const top = y - LEADERBOARD_START_AUDIO_H / 2;
  const music = resolveMusic(liveCustomisationData);
  const startAudio = resolveStartAudio(liveCustomisationData);

  return (
    <g className="fc-node fc-node--leaderboard-start-audio">
      <rect x={left + 2} y={top + 4} width={LEADERBOARD_START_AUDIO_W} height={LEADERBOARD_START_AUDIO_H} rx="14" fill="#000" fillOpacity="0.28" />
      <rect
        x={left}
        y={top}
        width={LEADERBOARD_START_AUDIO_W}
        height={LEADERBOARD_START_AUDIO_H}
        rx="14"
        fill={selected ? C.cardSel : C.card}
        stroke={selected ? C.sel : C.purple}
        strokeWidth={selected ? 2 : 1.4}
      />
      <line x1={left + 1} y1={top + 40} x2={left + LEADERBOARD_START_AUDIO_W - 1} y2={top + 40} stroke={C.border} strokeWidth="1" />

      <text x={left + 14} y={top + 20} fontSize="12" fontWeight="700" fill={C.text} style={{ pointerEvents: 'none', userSelect: 'none' }}>
        Music / Ambience + Start SFX
      </text>
      <text x={left + 14} y={top + 34} fontSize="9" fill={C.textMuted} style={{ pointerEvents: 'none', userSelect: 'none' }}>
        One start-audio node for music and start stingers
      </text>

      <SummaryRow
        x={left + 14}
        y={top + 54}
        width={LEADERBOARD_START_AUDIO_W - 28}
        title="Music / Ambience"
        subtitle={music.enabled ? music.label : 'Disabled'}
        active={music.enabled}
        color={C.green}
        onClick={onActivateMusic}
      />

      <SummaryRow
        x={left + 14}
        y={top + 110}
        width={LEADERBOARD_START_AUDIO_W - 28}
        title="Start SFX"
        subtitle={startAudio.enabled ? `${startAudio.count} clip${startAudio.count === 1 ? '' : 's'}${startAudio.count ? ` • ${startAudio.firstLabel}` : ''}` : 'Disabled'}
        active={startAudio.enabled}
        color={C.orange}
        onClick={onActivateStartAudio}
      />
    </g>
  );
}
